// extracted by mini-css-extract-plugin
export default {"root":"Search_root__R626K","container":"Search_container__P744e","options":"Search_options__YM2sQ"};